import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { RoleProvider } from "../../contexts/RoleContext";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, isAuthenticated, isLoading: authLoading } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      navigate("/login", { replace: true, state: { from: location } });
    } else if (
      !authLoading &&
      isAuthenticated &&
      user?.role !== "admin" &&
      user?.role !== "super_admin"
    ) {
      navigate("/", { replace: true });
    }
  }, [authLoading, isAuthenticated, user, navigate, location]);

  if (authLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <div>
          <CircularProgress />
          <Typography variant="body1" align="center" sx={{ mt: 2 }}>
            {t('loading')}
          </Typography>
        </div>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  const isAdmin = user?.role === "admin" || user?.role === "super_admin";

  if (!isAdmin) {
    return null;
  }

  return <RoleProvider>{children}</RoleProvider>;
};

export default AdminRoute;
